import { useMemo } from 'react';

type IconVariation = { d: string; viewBox: string; fill?: string };
export type IconVariations = { _24: IconVariation; _16?: IconVariation };

const useIconVariation = ({
  size = 24,
  icons,
}: {
  size?: number;
  icons: IconVariations[];
}): IconVariation[] =>
  useMemo(
    () =>
      icons.map((icon) => {
        if (icon._16 && size <= 16) return icon._16;
        return icon._24;
      }),
    [size, icons],
  );

export default useIconVariation;
